




































































































































































































































import {Vue, Component, Prop, Ref, Watch} from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class';
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import {SelectWings, TemplateInputWings, FieldTooltip, InputWings, TextareaWings} from "wings-ui-components";
import { SmsTextInputWings } from '@/components/SMS';
import { MsgTransports } from '@/store/types';
import { PushTemplateItemImpl } from '@/store/settings/templates/types';
import { PushApplicationItem } from '@/store/push/application/types';
import { GenericTemplateInterface } from '@/pages/Pages/Templates/GenericTemplate';
import CascadingOptions from '@/components/Others/CascadingOptions.vue';

Component.registerHooks([
  'beforeRouteLeave',
]);
@Component({components: {
    FieldTooltip,
    TemplateInputWings,
    GenericTemplate,
    SelectWings,
    SmsTextInputWings,
    InputWings,
    TextareaWings,
    CascadingOptions
}})
export default class PushTemplate extends Vue {
  @Prop() moderation!: boolean;
  @Ref('genericTemplate') genericTemplate!: GenericTemplateInterface;
  @Action("getPushApplications") actionGetApplications: any;
  @Action("getApplicationAttributes") actionGetApplicationAttributes: any;
  @Action("getGroupsApplications") actionGetGroupsApplications: any;

  @Getter("applicationAttributes") applicationAttributesList: any;
  @Getter("pushApplications") applicationsList: any;
  @Getter("groupsApplications") groupApplicationsList: any;

  private transport: MsgTransports = MsgTransports.PUSH;
  private templateObject: PushTemplateItemImpl = new PushTemplateItemImpl();
  activeApplication: string = 'application';
  app_groups: {id: number; name: string}[] = [];
  applications: {id: number; name: string}[] = [];
  app_groups_ids: number[] = [];
  applications_ids: number[] = [];
  applicationsValue = '';

  beforeRouteLeave(to:any, from:any, next:any) {
    this.genericTemplate.beforeLeave(to,from,next)
  }

  async onTemplateChangePartner(partner_id: number) {
    if (partner_id) {
      await this.actionGetApplications({partner_id});
      await this.actionGetGroupsApplications({partner_id});
    }
  }

  mounted() {
    if (!this.genericTemplate) return;

    const preSetup = () => {
      const template = this.genericTemplate.template;
      if (this.activeApplication === 'application') {
        template.applications_ids = this.applications_ids;
        template.group_selection_rule = null;
        template.app_selection_rule = null;
        if ((template.applications_ids?.length ?? 0) < 2) {
          template.app_by_date = undefined;
        }
      } else {
        template.app_groups_ids = this.app_groups_ids;
        template.app_by_date = null;
        if ((template.app_groups_ids?.length ?? 0) < 2){
          template.group_selection_rule = undefined;
        }
      }
    };

    const wrapWithPreHook = (obj: any, methodName: string, pre: () => void) => {
      const fn = obj?.[methodName];
      if (typeof fn !== 'function') return;

      const original = fn.bind(obj);
      obj[methodName] = async (...args: any[]) => {
        pre();
        return await original(...args);
      };
    };

    wrapWithPreHook(this.genericTemplate, 'onSaveItem', preSetup);
    wrapWithPreHook(this.genericTemplate, 'cloneTemplate', preSetup);
  }

  onAddApplication(id: number) {
    if (this.applications_ids.includes(id) || id == null) return;
    const option = this.applicationsList.find((item: any) => item.id == id);
    if (!option) return;
    this.applications.push(option);
    this.applications_ids.push(id);
  }

  onDeleteApplication(application: any) {
    const idx = this.applications.findIndex((item: any) => item.id == application.id);
    if (idx !== -1) {
      this.applications.splice(idx, 1);
      this.applications_ids.splice(idx, 1);
    }
  }

  onAddAppGroup(id: number) {
    if (this.app_groups_ids.includes(id) || id == null) return;
    const option = this.groupApplicationsList.find((item: any) => item.id == id);
    if (!option) return;
    this.app_groups.push(option);
    this.app_groups_ids.push(id);
  }

  onDeleteAppGroup(appGroup: any) {
    const idx = this.app_groups.findIndex((item: any) => item.id == appGroup.id);
    if (idx !== -1) {
      this.app_groups.splice(idx, 1);
      this.app_groups_ids.splice(idx, 1);
    }
  }

  onTemplateChanged(template: PushTemplateItemImpl) {
    if (!template.applications?.length) this.activeApplication = 'app_groups';
    this.applications = template.applications || [];
    this.applications_ids = this.applications.map(app => app.id);
    this.app_groups = template.app_groups || [];
    this.app_groups_ids = this.app_groups.map(app => app.id);
  }

  onLoadTemplate(status: string) {
    if (this.moderation) this.$emit('onLoadTemplate', status)
  }

  @Watch('activeApplication', { immediate: false })
  onChangeActiveApplication(newVal: string, oldVal: string) {
    this.applicationsValue = '';
    if (newVal === 'application') {
      this.app_groups = [];
      this.app_groups_ids = [];
      this.templateObject.app_groups = [];
      this.templateObject.app_groups_ids = [];
      this.templateObject.group_selection_rule = null;
      this.templateObject.app_selection_rule = null;
    } else {
      this.applications = [];
      this.applications_ids = [];
      this.templateObject.applications = [];
      this.templateObject.applications_ids = [];
      this.templateObject.app_by_date = null;
    }
  }
}
